var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3H9a4 4 0 0 0-4 4v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.5c0-1.184 0-2.03.074-2.684c.073-.643.21-1.035.443-1.338a2.5 2.5 0 0 1 .461-.461c.303-.232.696-.37 1.338-.443c.653-.073 1.5-.074 2.684-.074s2.03 0 2.684.074c.642.073 1.035.21 1.338.443q.26.2.461.461c.232.303.37.695.443 1.338c.073.653.074 1.5.074 2.684v4c0 1.184 0 2.03-.074 2.684c-.073.642-.21 1.035-.443 1.338a2.5 2.5 0 0 1-.461.461c-.302.232-.695.37-1.338.443c-.653.073-1.5.074-2.684.074s-2.03 0-2.684-.074c-.643-.073-1.035-.21-1.338-.443a2.5 2.5 0 0 1-.461-.461c-.232-.302-.37-.695-.443-1.338c-.073-.653-.074-1.5-.074-2.684z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.b94ce9236934af832b173e8dd2a4fa64.svg";
export { ForwardRef as ReactComponent };